export default "__VITE_ASSET__DHU8VmLU__"